import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 0.856079L22 6.41163V9.00004H2V6.41163L12 0.856079ZM2 21H22V23H2V21Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7 19H5V11H7V19Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13 19H11V11H13V19Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19 19H17V11H19V19Z"}}]};

const InstitutionFilled = Vue.extend<IconProps>({
  name: 'InstitutionFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'institution-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default InstitutionFilled;
